import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

export const PromoBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const promoDismissed = localStorage.getItem('promo_dismissed');
    if (promoDismissed) {
      setDismissed(true);
      setIsVisible(false);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('promo_dismissed', 'true');
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="bg-[#1a1a1a] text-white overflow-hidden"
          data-testid="promo-bar"
        >
          <div className="max-w-7xl mx-auto px-4 py-3">
            <div className="flex items-center justify-center gap-6 text-sm">
              {/* 48hr Notice */}
              <div className="flex items-center gap-2">
                <Clock className="w-4 h-4 text-[#D4AF37]" />
                <span>Cakes ready for collection <strong className="text-[#D4AF37]">within 48 hours</strong></span>
              </div>
              
              <span className="hidden sm:block text-stone-500">|</span>
              
              {/* Promo Code */}
              <div className="hidden sm:flex items-center gap-2">
                <span>First order?</span>
                <span className="font-mono bg-[#8D6E63] px-2 py-0.5 rounded text-white font-bold">
                  MADBRO10
                </span>
                <span>for 10% off</span>
              </div>
              
              <span className="hidden lg:block text-stone-500">|</span>
              
              {/* Shop Link */}
              <Link 
                to="/shop?category=cakes" 
                className="hidden lg:flex items-center gap-1 text-[#D4AF37] hover:underline font-medium"
              >
                Order Celebration Cakes →
              </Link>
            </div>
          </div>
          
          <button
            onClick={handleDismiss}
            className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-white/10 rounded-full transition-colors"
            data-testid="promo-dismiss"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PromoBar;
